<mat-dialog-actions class="justify-content-between">
  <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'PHARMACY.INVENTORY_ITEM' | translate }}</h3>
  <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'PHARMACY.INVENTORY_ITEM' | translate }}</h3>
  <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="inventoryForm">
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.DRUG_NAME' | translate }}</mat-label>
          <input type="text" matInput [formControl]="drugCtrl" [matAutocomplete]="autoDrug"
            placeholder="{{ 'PHARMACY.SEARCH_DRUG' | translate }}" />
          <mat-autocomplete #autoDrug="matAutocomplete" [displayWith]="displayDrug"
            (optionSelected)="onDrugSelected($event.option.value)">
            <mat-option *ngFor="let drug of filteredDrugs$ | async" [value]="drug">
              {{ drug.name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="inventoryForm.get('drugId')?.hasError('required')">
            {{ 'REQUIRED.NAME' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.SELLING_PRICE_MRP' | translate }}</mat-label>
          <input type="number" matInput formControlName="sellingPrice"
            placeholder="{{ 'PHARMACY.SELLING_PRICE_MRP' | translate }}" />
          <mat-error *ngIf="inventoryForm.get('sellingPrice')?.hasError('required')">
            {{ 'REQUIRED.NAME' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.GST_PERCENT' | translate }}</mat-label>
          <input type="number" matInput formControlName="gstPercentage"
            placeholder="{{ 'PHARMACY.GST_PERCENT' | translate }}" />
          <mat-error *ngIf="inventoryForm.get('gstPercentage')?.hasError('required')">
            {{ 'REQUIRED.NAME' | translate }}
          </mat-error>
          <mat-error *ngIf="inventoryForm.get('gstPercentage')?.hasError('max')">
            {{ 'REQUIRED.GST_NUMBER' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'PHARMACY.REORDER_LEVEL' | translate }}</mat-label>
          <input type="number" matInput formControlName="reorderLevel"
            placeholder="{{ 'PHARMACY.REORDER_LEVEL' | translate }}" />
          <mat-error *ngIf="inventoryForm.get('reorderLevel')?.hasError('required')">
            {{ 'REQUIRED.NAME' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
  <div class="row p-r-16 w-100">
    <div class="col-lg-8"></div>
    <div class="col-lg-4 d-flex justify-content-end">
      <button mat-stroked-button class="m-r-5" (click)="onClose()">
        {{ 'BUTTON.BTN_CLOSE' | translate }}
      </button>
      <button mat-flat-button color="primary" class="m-l-4" (click)="onSave()" [disabled]="inventoryForm.invalid">
        {{ 'BUTTON.BTN_SAVE' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>